import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DscMensajeSpinner, IdCaptcha } from 'src/app/general/variables';
import { ModalMensaje } from 'src/app/models/ModalMensaje';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { NavModalComponent } from '../nav-modal/nav-modal.component';

@Component({
  selector: 'app-modal-mensaje',
  templateUrl: './modal-mensaje.component.html',
  styleUrls: ['./modal-mensaje.component.css']
})
export class ModalMensajeComponent implements OnInit {

  flgBtnRegresar = false;
  flgHTML = false;
  boolFlgCaptcha = false;
  boolFlgNormal = true;
  strDscError = '';
  strDscMensajeSpinner = DscMensajeSpinner;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor( public dialogRef: MatDialogRef<ModalMensajeComponent>,
               @Inject(MAT_DIALOG_DATA) public data: ModalMensaje,
               protected externosService: ExternosService,
               private spinner: NgxSpinnerService,
               public dialog: MatDialog, ) { }

  ngOnInit() {

    let boolFlgDataHTML = this.data.flgHtml;

    this.boolFlgCaptcha = this.data.flgCaptcha;

    this.boolFlgCaptcha = (this.boolFlgCaptcha ? this.boolFlgCaptcha : false);

    this.boolFlgNormal = !this.boolFlgCaptcha;

    boolFlgDataHTML = (boolFlgDataHTML ? boolFlgDataHTML : false);

    this.flgHTML = boolFlgDataHTML;

    this.flgBtnRegresar = this.data.flgRegresar;

    this.navModalC.setDatosNavModal2(this.data.titulo);

  }

  _regresar() {

    let dataReturn: any;

    if (this.boolFlgCaptcha) {

      dataReturn = '';

    } else {

      dataReturn = true;

    }

    this.dialogRef.close(dataReturn);



  }

  _aceptar() {



    this.strDscError = '';

    if (this.boolFlgCaptcha) {

      const valCaptcha = (document.getElementById(IdCaptcha) as HTMLInputElement).value;

      if (valCaptcha != 'OK') {

        this.strDscError = 'Ingrese el Captcha correctamente, por favor verifique';
        return;

      }

      this.spinner.show();

      this.externosService.obtenerToken().subscribe(data => {

      this.spinner.hide();

      if (data != null) {

        this.dialogRef.close(data.token);

      }


    },
    err => {
      this.spinner.hide();
      console.log(err);
    });

    } else {

      this.dialogRef.close(false);

    }

  }

  get boolFlgError() {

    return this.strDscError.length > 0;

  }

}
